import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { ScreenId } from "@/js/value-objects/screen-id";
const disasterDeliveryRepository = RepositoryFactory.get("disasterDelivery");

const state = () => ({
  data: {}
});
const getters = {};
const mutations = {
  setDisaster(state, payload) {
    state.data = payload;
  }
};
const actions = {
  async loadDisasterDelivery(context, payload) {
    const disasters = await disasterDeliveryRepository.list(
      ScreenId.SF0302,
      payload
    );
    if (disasters.status < 300) {
      context.commit("setDisaster", disasters.data);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
